/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-form-action-factory.ts to modify the generation of this file.

import { Recaptcha } from 'src/helpers/Forms/SubmitActions/Actions/Recaptcha';
import { RedirectToUrl } from 'src/helpers/Forms/SubmitActions/Actions/RedirectToUrl';
import { ReferralConsultation } from 'src/helpers/Forms/SubmitActions/Actions/ReferralConsultation';
import { SFMCTransactionalMessagingSendEmail } from 'src/helpers/Forms/SubmitActions/Actions/SFMCTransactionalMessagingSendEmail';
import { SalesforceWebToLead } from 'src/helpers/Forms/SubmitActions/Actions/SalesforceWebToLead';
import { SaveToDatabase } from 'src/helpers/Forms/SubmitActions/Actions/SaveToDatabase';
import { SendEmail } from 'src/helpers/Forms/SubmitActions/Actions/SendEmail';
import { SendGTMEvent } from 'src/helpers/Forms/SubmitActions/Actions/SendGTMEvent';
import { WarrantyRegistration } from 'src/helpers/Forms/SubmitActions/Actions/WarrantyRegistration';
import { MoveToPage } from 'src/helpers/Forms/SubmitActions/Actions/RbA/MoveToPage';
import { SendText } from 'src/helpers/Forms/SubmitActions/Actions/RbA/SendText';
import { SubmitJobApplicant } from 'src/helpers/Forms/SubmitActions/Actions/RbA/SubmitJobApplicant';
import { SubmitJobLeadGen } from 'src/helpers/Forms/SubmitActions/Actions/RbA/SubmitJobLeadGen';
import { SubmitOnlineSchedulingIncomplete } from 'src/helpers/Forms/SubmitActions/Actions/RbA/SubmitOnlineSchedulingIncomplete';
import { SubmitOnlineSchedulingPrimary } from 'src/helpers/Forms/SubmitActions/Actions/RbA/SubmitOnlineSchedulingPrimary';
import { SubmitOnlineSchedulingSecondary } from 'src/helpers/Forms/SubmitActions/Actions/RbA/SubmitOnlineSchedulingSecondary';
import { SubmitOnlineSchedulingTertiary } from 'src/helpers/Forms/SubmitActions/Actions/RbA/SubmitOnlineSchedulingTertiary';
import { SubmitRbaLead } from 'src/helpers/Forms/SubmitActions/Actions/RbA/SubmitRbaLead';
import { UpdateAffiliate } from 'src/helpers/Forms/SubmitActions/Actions/RbA/UpdateAffiliate';

const actions = new Map();

actions.set('recaptcha',Recaptcha)
actions.set('redirecttourl',RedirectToUrl)
actions.set('referralconsultation',ReferralConsultation)
actions.set('sfmctransactionalmessagingsendemail',SFMCTransactionalMessagingSendEmail)
actions.set('salesforcewebtolead',SalesforceWebToLead)
actions.set('savetodatabase',SaveToDatabase)
actions.set('sendemail',SendEmail)
actions.set('sendgtmevent',SendGTMEvent)
actions.set('warrantyregistration',WarrantyRegistration)
actions.set('movetopage',MoveToPage)
actions.set('sendtext',SendText)
actions.set('submitjobapplicant',SubmitJobApplicant)
actions.set('submitjobleadgen',SubmitJobLeadGen)
actions.set('submitonlineschedulingincomplete',SubmitOnlineSchedulingIncomplete)
actions.set('submitonlineschedulingprimary',SubmitOnlineSchedulingPrimary)
actions.set('submitonlineschedulingsecondary',SubmitOnlineSchedulingSecondary)
actions.set('submitonlineschedulingtertiary',SubmitOnlineSchedulingTertiary)
actions.set('submitrbalead',SubmitRbaLead)
actions.set('updateaffiliate',UpdateAffiliate)

import { IBaseSubmitAction } from 'src/helpers/Forms/SubmitActions/BaseSubmitAction';
import { FormProps } from 'components/forms/Form/Form';
import { FormFieldProps } from 'lib/forms';
import { ButtonProps } from 'src/helpers/Forms/Fields/NavigationButton/Button';

/**
 * @function constructor
 * @param  formData: unknown - Final object of the form fields and value mappings
 * @param  formProps: FormProps - Whole form level props
 * @param  actionFieldsProps: Foundation.EnterpriseWeb.Core.FieldSets.Forms.SubmitAction['fields'] - current action related fields
 */
export function formActionFactory(
  action: Partial<FormFieldProps>,
  formData: unknown,
  formProps?: FormProps,
  submitButtonProps?: ButtonProps,
  context?: any
): IBaseSubmitAction | undefined {
  const actionClass = actions.get(action.templateName?.replaceAll(' ', '').toLowerCase());

  if (!!actionClass)
    return new actionClass({
      formData: formData,
      formProps: formProps,
      actionFieldsProps: action.fields,
      submitButtonProps: submitButtonProps,
      context: context,
    });

  console.error(`No action handler defined for ${action.templateName}`);

  return undefined;
}
